import digitalScreen from "../../assets/images/whatWeDoImages/advertisingImg.png";
import supermarketScreen from "../../assets/images/whatWeDoImages/supermarketScreen.jpg";
import branding from "../../assets/images/whatWeDoImages/brandingImg.png";
import advertising from "../../assets/images/whatWeDoImages/liptionImg.png";

export const SliderData = [
    {
        images: digitalScreen,
        title:"Mall Screens",
        content:"To help medium-sized and big brands increase their bottom-line by achieving top-of-mind awareness with their target audience using our large network of compelling and innovative advertising assets while assuring them of measurable visibility.",
        path:"digital"
    },
    {
        images: supermarketScreen,
        title:"Supermarket Screens",
        content:" Our mission is to build the largest network of compelling and innovative out of home advertising assets in Africa.",
        path:"digital"
    },
    {
        images: advertising,
        title:"Branding",
        content:" Nimbus is in the process of building the largest digital signage network at high-volume venues in Africa",
        path:"branding"
    },
    {
        images: branding,
        title:"Activation",
        content:"To help medium-sized and big brands increase their bottom-line by achieving top-of-mind awareness with their target audience using our large network of compelling and innovative advertising assets while assuring them of measurable visibility.",
        path:"activation"
    }
]